import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {
    Input,
    Label,
    Col,
    Popover,
    PopoverBody,
    FormGroup
} from 'reactstrap';
import IconContainer from '../../../commonComponents/iconContainer/IconContainer';
import './InputWithPopover.css';
import _ from 'lodash';
import { sharedLabelsPath } from "../../../../reducers/common/localization";
import {STATUSES} from "../../../commonComponents/customSelect/CustomSelect";

class InputWithPopover extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.editMode !== nextProps.editMode) {
            this.setState({isOpen: nextProps.editMode});
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.editMode !== prevProps.editMode && this.props.editMode) {
            if (this.props.type === 'select') {
                this.inputRef.focus();
            } else if (!_.isNil(this.inputRef.input)) {
                ReactDOM.findDOMNode(this.inputRef.input).focus();
            } else {
                ReactDOM.findDOMNode(this.inputRef).focus();
            }
        }
    }

    render() {
        if (!_.isNil(this.props.oldValue)) {
            let className = 'validate-mode ' + (this.props.editMode ? 'check-for-validate ' : '') + (this.props.className || '');
            if (!this.props.editMode && this.props.newValueText !== (this.props.oldValueText || this.props.oldValue)) {
                className += ' updated '
            }
            let value = typeof (this.props.oldValue) === 'object' ? 'selected' : 'value';
            let componentProps = {
                type: this.props.type,
                id: this.props.id,
                [value]: this.props.proposedValue,
                className: className,
                title: this.renderTitle(),
                onChange: this.props.onChangeProposedValue,
                placeholder: this.props.editMode ? _.get(this.props.translation, 'accreditation.popover.proposed_value_input_placeholder') : "",
                onClick: this.showPopover,
                onFocus: this.showPopover,
                onKeyDown: this.handleKeyDown,
                autoComplete: "off",
                ...this.props.componentProps
            };
            if (this.props.type === 'select') {
                componentProps.innerRef = (elem) => {this.inputRef = elem};
                componentProps.status = this.props.editMode ? STATUSES.ERROR : null;
            } else {
                componentProps.ref = (elem) => {this.inputRef = elem};
            }
            return (
                <FormGroup row>
                    <Col sm={11}>
                        <div
                            className="input-with-popover-container"
                            ref={(elem) => this.popupWithInputContainerRef = elem}
                            tabIndex={0}
                            onBlur={this.handleBlur}
                        >
                            {React.createElement(
                                this.props.componentType || Input,
                                componentProps,
                                this.props.children
                            )}

                            {this.renderPopover()}

                        </div>
                    </Col>
                    <Col sm={1} className='icon-container'>
                        {this.renderIcon()}
                    </Col>
                </FormGroup>
            );
        } else {
            return null;
        }
    }

    renderPopover = () => {
        if (this.props.editMode) {
            return (
                <Popover
                    placement={this.props.popoverPlacement || "top"}
                    isOpen={this.state.isOpen}
                    target={this.props.id}
                    container={this.popupWithInputContainerRef}
                >
                    <PopoverBody className="popover-body">
                        <div className='icon-hide-popover-container'>
                            <IconContainer 
                                icon="clear" 
                                className='icon-hide-popover'
                                onClick={this.hidePopover}
                                title={_.get(this.props.translation, sharedLabelsPath.cancel_button)}
                            />
                        </div>
                        <Label>{_.get(this.props.translation, 'accreditation.popover.old_value_label')}: {this.props.oldValueText || this.props.oldValue}</Label>
                        <Label>{_.get(this.props.translation, 'accreditation.popover.proposed_value_label')}: {this.props.newValueText}</Label>
                        <Label>{_.get(this.props.translation, 'accreditation.popover.message_label')}: </Label>
                        <Input
                            type="textarea"
                            className="textarea-message"
                            value={this.props.message}
                            onChange={this.props.onChangeMessage}
                            placeholder={_.get(this.props.translation, 'accreditation.popover.message_placeholder')}
                            ref={(elem) => this.textAreaRef = elem}
                        />
                    </PopoverBody>
                </Popover>
            );
        }
    };

    renderTitle = () => {
        if (this.props.isOpen || !(this.props.proposedValueText || this.props.proposedValue)) {
            return '';
        }

        let title = '';
        if (this.props.oldValueText || this.props.oldValue) {
            title = _.get(this.props.translation, 'accreditation.popover.old_value_label') + ': ' + (this.props.oldValueText || this.props.oldValue);
            if (this.props.message) {
                title += '\n' + _.get(this.props.translation, 'accreditation.popover.message_label') + ': ' + (this.props.message);
            }
        }

        return title;
    };

    renderIcon = () => {
        let icon = this.props.editMode ? "clear" : "create";
        let title = this.props.editMode ?
            _.get(this.props.translation, 'accreditation.popover.discard_changes_label')
            :
            _.get(this.props.translation, 'accreditation.popover.edit_field_label');

        return <IconContainer 
            className="input-with-popover-icon" 
            key={this.props.editMode}
            icon={icon} 
            onClick={this.props.onChangeToggle}
            title={title}
        />;
    };

    handleKeyDown = e => {
        let key = e.charCode || e.keyCode || 0;
        if (key === 13) {
            e.preventDefault();
        }
    };

    showPopover = () => {
        if (!this.props.editMode) {
            this.props.onChangeToggle();
        }

        this.setState({isOpen: true});
    };

    hidePopover = () => {
        if (this.props.editMode && this.state.isOpen) {
            this.setState({isOpen: false})
        }
    };

    handleBlur = (e) => {
        let popupWithInputContainerNode = ReactDOM.findDOMNode(this.popupWithInputContainerRef);
        let inputNode = ReactDOM.findDOMNode(this.inputRef.input);
        let textAreaNode = ReactDOM.findDOMNode(this.textAreaRef);
        let relatedTarget = e.relatedTarget;

        if (_.isNil(relatedTarget) || (relatedTarget !== inputNode && relatedTarget !== textAreaNode && relatedTarget !== popupWithInputContainerNode)) {
            this.hidePopover();
        }
    }
}

InputWithPopover.propTypes = {
    id: PropTypes.string.isRequired,
    editMode: PropTypes.bool,
    oldValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    oldValueText: PropTypes.string,
    newValueText: PropTypes.string,
    proposedValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    proposedValueText: PropTypes.string,
    message: PropTypes.string,
    type: PropTypes.string,
    popoverPlacement: PropTypes.string,
    componentProps: PropTypes.object,
    translation: PropTypes.object.isRequired,
    onChangeProposedValue: PropTypes.func.isRequired,
    onChangeMessage: PropTypes.func.isRequired,
    onChangeToggle: PropTypes.func.isRequired
};

export default InputWithPopover;



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/validateAccreditation/inputWithPopover/InputWithPopover.js